import { SxProps, Theme } from "@mui/material";

export const darkInput: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    background: "rgba(255,255,255,0.05)",
    borderRadius: "12px",
    color: "white",
    fontFamily: "'Barlow', sans-serif",
    "& fieldset": { borderColor: "rgba(255,255,255,0.12)" },
    "&:hover fieldset": { borderColor: "rgba(248,173,62,0.4)" },
    "&.Mui-focused fieldset": { borderColor: "#F8AD3E" },
  },
  "& .MuiInputLabel-root": {
    color: "rgba(255,255,255,0.5)",
    fontFamily: "'Barlow', sans-serif",
  },
  "& .MuiInputLabel-root.Mui-focused": { color: "#F8AD3E" },
};

export const ctaButton: SxProps<Theme> = {
  background: "linear-gradient(90deg, #f97316, #fb923c)",
  borderRadius: "50px",
  py: 1.75,
  fontSize: "1rem",
  fontWeight: 700,
  fontFamily: "'Barlow', sans-serif",
  textTransform: "none",
  boxShadow: "0 4px 24px rgba(249,115,22,0.35)",
  "&:hover": { background: "linear-gradient(90deg, #ea6c0a, #f97316)" },
};

export const gradientText: SxProps<Theme> = {
  background: "linear-gradient(90deg, #F8AD3E, #f97316)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const eyebrow: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontSize: "0.72rem",
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "#F8AD3E",
  mb: 1.5,
};

export const formHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 700,
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  mb: 1,
  color: "white",
};

export const formSubtext: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: "1rem",
  mb: 4,
};

export const languageSelect: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    background: "rgba(255,255,255,0.05)",
    borderRadius: "12px",
    color: "white",
    fontFamily: "'Barlow', sans-serif",
    "& fieldset": { borderColor: "rgba(255,255,255,0.12)" },
    "&:hover fieldset": { borderColor: "rgba(248,173,62,0.4)" },
    "&.Mui-focused fieldset": { borderColor: "#F8AD3E" },
  },
  "& .MuiInputLabel-root": {
    color: "rgba(255,255,255,0.5)",
    fontFamily: "'Barlow', sans-serif",
  },
  "& .MuiInputLabel-root.Mui-focused": { color: "#F8AD3E" },
  "& .MuiSelect-icon": { color: "rgba(255,255,255,0.4)" },
};

export const languageMenuPaper: SxProps<Theme> = {
  background: "#0b1120",
  border: "1px solid rgba(255,255,255,0.1)",
  borderRadius: "12px",
  "& .MuiMenuItem-root": {
    fontFamily: "'Barlow', sans-serif",
    color: "rgba(255,255,255,0.82)",
    "&:hover": { background: "rgba(248,173,62,0.1)" },
    "&.Mui-selected": { background: "rgba(248,173,62,0.15)", color: "#F8AD3E" },
  },
};

export const pageWrapper: SxProps<Theme> = {
  minHeight: "100vh",
  background: "#040922",
  position: "relative",
  "@keyframes fadeUp": {
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
};

export const backgroundGlow: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background:
    "radial-gradient(ellipse at 20% 10%, rgba(248,173,62,0.06) 0%, transparent 60%), radial-gradient(ellipse at 80% 80%, rgba(249,115,22,0.05) 0%, transparent 60%)",
  pointerEvents: "none",
};

export const formCard: SxProps<Theme> = {
  background: "#0b1120",
  border: "1px solid rgba(248,173,62,0.14)",
  borderRadius: "20px",
  p: { xs: 3, md: 5 },
  animation: "fadeUp 0.45s ease both",
  position: "relative",
  overflow: "hidden",
};

export const successIconWrapper: SxProps<Theme> = {
  width: 80,
  height: 80,
  borderRadius: "50%",
  background: "rgba(248,173,62,0.1)",
  border: "1px solid rgba(248,173,62,0.3)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  mx: "auto",
  mb: 3,
};

export const successHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 700,
  fontSize: { xs: "1.6rem", md: "2rem" },
  mb: 1.5,
  color: "white",
};

export const successEmailLabel: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: "1rem",
  mb: 1,
};

export const successEmailValue: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "#F8AD3E",
  fontWeight: 600,
  fontSize: "1rem",
  mb: 3,
};

export const successHelpText: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.5)",
  fontSize: "0.9rem",
  maxWidth: 340,
  mx: "auto",
};

export const backButton: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.35)",
  textTransform: "none",
  fontSize: "0.85rem",
  px: 0,
  "&:hover": { color: "#F8AD3E", background: "transparent" },
};
